import { z } from "zod";
import { stripSearchParams, type SearchMiddleware } from "@tanstack/react-router";
import { TokenOperationStatus, TokenOperationType } from "@/types/api/tokenOperation";
import {
  defaultPageSearch,
  optionalCalendarDay,
  optionalPage,
  optionalSearch,
} from "./shared";

const tokenOperationSortSchema = z.enum([
  "createdAt:asc",
  "createdAt:desc",
  "type:asc",
  "type:desc",
  "status:asc",
  "status:desc",
]);

export const transactionsSearchDefaults = {
  ...defaultPageSearch,
  sort: "createdAt:desc" as const,
};

export const transactionsSearchSchema = z.object({
  type: optionalSearch(
    z.enum([TokenOperationType.OnRamp, TokenOperationType.OffRamp]),
  ),
  status: optionalSearch(
    z.enum([
      TokenOperationStatus.Pending,
      TokenOperationStatus.Confirmed,
      TokenOperationStatus.Failed,
    ]),
  ),
  createdAfter: optionalCalendarDay,
  createdBefore: optionalCalendarDay,
  sort: optionalSearch(tokenOperationSortSchema),
  page: optionalPage,
});

export type TransactionsSearch = z.infer<typeof transactionsSearchSchema>;

export const transactionsSearchMiddlewares: SearchMiddleware<TransactionsSearch>[] = [
  stripSearchParams(transactionsSearchDefaults) as SearchMiddleware<TransactionsSearch>,
];
